module.exports = __webpack_public_path__ + "static/media/image_3_2.3c4d754b.svg";